import axios from 'axios';

/**
 * A number, or a string containing a number.
 * @property {string} name
 * @property {string} email
 * @property {string} message
 */

const chatApi = {
    /**
     *
     * @param {object} newChatRequest
     * @param {string} newChatRequest.name
     * @returns {Promise<void>}
     */
    async newChat(newChatRequest) {
        const url = '/api/chat';
        const response = await axios.post(url, newChatRequest);
        return response.data.response;
    },
    /**
     * @param {string} chatId
     * @param {Object} chatMessageRequest
     * @param {string} chatMessageRequest.chatId
     * @param {string} chatMessageRequest.message
     * @param {number} chatMessageRequest.timestamp
     * @param {string} chatMessageRequest.chatMessage
     * @param {number} chatMessageRequest.temperature
     * @param {number} chatMessageRequest.indexName
     * @returns {Promise<void>}
     */
    async newChatMessage(chatId, chatMessageRequest) {
        const url = `/api/chat/${chatId}/message`;
        chatMessageRequest.timestamp = new Date().getTime()
        const response = await axios.post(url, chatMessageRequest);
        return response.data.response;
    },
    async getChats() {
        const responseData = await axios.get('/api/chat');
        const chats = responseData.data.response;
        chats.forEach(chat => {
            const noDecimal = parseInt(chat.timestamp);
            chat.timestamp = new Date(noDecimal);
        });
        return chats;
    },
    async rating(message, rating) {
        ///api/chat/{chat_id}/message/{message_id}/rating/{rating}
        const url = `/api/chat/${message.chatId}/message/${message.originalId}/rating/${rating}`;
        const response = await axios.post(url, null);
        return response.data;
    },
    async getChatMessages(chatId) {
        const response = await axios.get(`/api/chat/${chatId}/message`);
        return response.data.response;
    },
    async getCompetencePrompt(messageRequest) {
        const url = `/api/competence`;
        const response = await axios.post(url, messageRequest);
        return response.data.response;
    },
    async getSuggestedStudies(chatId, request) {
        const url = `/api/chat/${chatId}/message-stream`;
        const response = await axios.post(url, request);
        return response.data;
    },
    async getStudyPrograms() {
        const response = await axios.get('/api/study-programs');
        return response.data.response;
    }
};

export default chatApi;
